import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-community/core';
import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';

import { AgCellWrapperComponent } from '@shared/ag-components/ag-cell-wrapper/ag-cell-wrapper.component';
import { AuxIconName } from '@shared/components/icon/icon';
import { IconComponent } from '@shared/components/icon/icon.component';
import { Utils } from '@shared/utils/utils';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent, NgClass],
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
  template: `
    <div class="flex items-center justify-end whitespace-nowrap" [attr.auto-qa]="autoTestAttribute">
      <div>{{ value !== 0 ? value : '—' }}</div>
      @if (icon) {
        <aux-icon [name]="icon" class="ml-1.5 flex-shrink-0" [ngClass]="colorClass" />
      }
    </div>
  `,
})
export class VariationStatusComponent
  extends AgCellWrapperComponent
  implements ICellRendererAngularComp
{
  colorClass!: string;
  icon!: AuxIconName;
  textClass!: string;
  value!: number | string;

  agInit(
    params: ICellRendererParams & {
      reverse?: boolean;
    }
  ): void {
    const variation = params.value || 0;

    let showUp = params.reverse ? variation < 0 : variation > 0;
    let showDown = params.reverse ? variation > 0 : variation < 0;

    const isDiscountPercent = !!(
      params.data &&
      params.data.cost_category === 'Discount' &&
      params.colDef?.field?.includes('::VAR_PERC::SNAPSHOT') &&
      params.valueFormatted !== Utils.zeroHyphen
    );

    if (isDiscountPercent) {
      showUp = !showUp;
      showDown = !showDown;
    }

    if (showUp) {
      this.colorClass = 'text-aux-red-dark';
      this.icon = 'CircleArrowUp';
    } else if (showDown) {
      this.colorClass = 'text-aux-green-dark';
      this.icon = 'CircleArrowDown';
    }

    this.value = params.formatValue ? params.formatValue(Math.abs(variation)) : Math.abs(variation);

    this.autoTestAttribute = this.getAutoTestAttribute(params);
  }
}
